import { generateImageEffects } from '@/api/imageEffects';
import type { CanvasEx } from '@/typings/canvas';
import type { ImagePlaceholderElement } from '@/typings/customilyElements/canvasElements';
import { ImageEffectType } from '@/typings/customilyElements/imageEffectType';

export class ImageEffectsService {
    private static async setImageElement(
        element: ImagePlaceholderElement,
        base64Image: string,
        canvas: CanvasEx
    ): Promise<void> {
        return new Promise((resolve, reject) => {
            const image = new Image();

            image.onload = () => {
                try {
                    element.setElement(image);
                    canvas.requestRenderAll();
                    resolve();
                } catch (error) {
                    console.error('Error setting image element:', error);
                    reject(new Error(`Failed to set image element: ${error}`));
                }
            };

            image.onerror = (event) => {
                const errorMessage = 'Failed to load image with effects';
                console.error(errorMessage, event);
                reject(new Error(errorMessage));
            };

            image.crossOrigin = 'Anonymous';
            image.src = `data:image/webp;base64,${base64Image}`;
        });
    }
    public static async processImageEffects(data: {
        object: ImagePlaceholderElement;
        canvas: CanvasEx;
        username: string;
        file: File;
    }) {
        const { object, canvas, username, file } = data;
        const imageEffects = object?.imageEffects;
        let parsedImageEffects: ImageEffectType[] = [];

        try {
            parsedImageEffects =
                typeof imageEffects === 'string' ? (JSON.parse(imageEffects) as ImageEffectType[]) : imageEffects || [];
        } catch (_error) {
            parsedImageEffects = imageEffects || [];
        }

        if (!parsedImageEffects?.length) {
            return;
        }

        const response = await generateImageEffects({
            imageEffects: parsedImageEffects,
            username,
            file
        });

        await this.setImageElement(object, response, canvas);
    }
}
